<template lang="html">
  <v-page class="client wallet" :profile="profile">
    <v-topbar :profile="profile" />
    <v-breadcrumb :steps="[{ label: 'Carteira' }]" />

    <v-container class="mt-3">
      <v-alert close v-if="balances_data.total == 0">
        <strong>Você não possui créditos na sua carteira</strong><br />
        Para cada profissional que você contratar, é preciso comprar créditos
        para que ele tenha horas liberadas para trabalhar. O total de créditos
        da sua carteira é a soma dos créditos de cada profissional. Conforme as
        horas forem sendo trabalhadas e pagas, seus créditos vão sendo
        debitados.
        <v-link
          v-if="balances_data.details.length === 0"
          :to="{ name: 'client-search' }"
          >Comece explorando a nossa rede de profissionais!</v-link
        >
      </v-alert>
      <v-row class="size-2">
        <v-col :xs="12" :sm="12" :lg="4">
          <v-card class="m-0">
            <v-text slot="title" tag="h5" class="d-flex align-items-center"
              >Créditos
              <small class="ml-auto">
                <small>total:</small>
                {{ balances_data.total | currency }}</small
              ></v-text
            >
            <v-text
              v-if="balances_data.details.length === 0"
              slot="title"
              tag="h6"
              class="d-flex align-items-center"
              >Para comprar créditos, é necessário contratar profissionais
              primeiro.</v-text
            >
            <v-list>
              <v-item
                tag="li"
                v-for="balance in balances_data.details"
                :key="n"
                class=""
              >
                <div class="d-flex justify-content-between align-items-center">
                  <v-link
                    @click="openVibbranteNewTab(balance.vibbrante_slug)"
                    >{{ balance.vibbrante_name }}</v-link
                  >
                  <div>
                    {{ balance.credit | currency }}
                    <v-helper
                      class="text-muted"
                      title="Créditos do profissional"
                      placement="top"
                    >
                      Créditos disponíveis para esse profissional. É necessário
                      terem créditos para o profissional poder ter horas
                      liberadas para trabalhar.
                    </v-helper>
                  </div>
                </div>
                <div class="text-right">
                  <small>
                    <span v-if="balance.next_paid_date">
                      <span
                        class="badge badge-warning"
                        v-if="balance.pending_payments === true"
                        >Pendente</span
                      >
                      Sprint atual fecha em
                      {{ balance.next_paid_date | moment('DD/MM') }}<br />
                      <span class="text-danger">
                        Pagamento previsto:
                        {{ balance.next_paid_value | currency }}</span
                      >
                      ({{ balance.next_paid_hours }}h trabalhadas)
                      <v-helper
                        class="text-muted"
                        title="Pagamento previsto"
                        placement="top"
                      >
                        Previsão do próximo pagamento para esse profissional na
                        data de fechamento da sprint corrente. É considerada a
                        soma das horas trabalhadas até o momento na sprint.
                      </v-helper>
                    </span>
                  </small>
                </div>
              </v-item>
            </v-list>
            <v-inner :size="2" class="d-flex justify-content-center">
              <v-button
                class="primary block"
                @click="add_credit_modal_show = true"
                :disabled="balances_data.details.length === 0"
                >Comprar créditos</v-button
              >
            </v-inner>
          </v-card>
          <!-- <v-alert class="danger"><v-icon name="feedback" size="2"/> Atenção, seus créditos estão acabando e você tem um débito de <b>R$60.000</b></v-alert> -->
        </v-col>
        <v-col :xs="12" :sm="12" :lg="8">
          <v-card class="statement m-0">
            <v-text slot="title" tag="h5" class="statement-title">
              Extrato
              <v-input
                type="datepicker"
                :dateFormat="'MM/yyyy'"
                class="dropdown-right ml-3"
                :minimumView="'month'"
                :maximumView="'month'"
                :size="1"
                placeholder="Selecione um mês"
                v-model="selected_month"
              ></v-input>
            </v-text>
            <v-text
              slot="title"
              tag="h6"
              class="statement-title"
              v-if="extract_data.length === 0"
            >
              Nenhuma movimentação encontrada.
            </v-text>

            <v-list>
              <!--v-item tag="li" class="d-flex justify-content-between align-items-center">
                <span class=""><v-icon class="text-danger" name="cash-down"/>  Pagou <b>R$5.000</b> referente a <b>Sprint 3</b> para  <v-link @click="user_modal_show = true">Pedro</v-link> - <v-link>Baixar NF</v-link>
                </span>
                <small>01/09/2018</small>
              </v-item -->
              <v-item
                tag="li"
                v-for="release in extract_data"
                class="d-flex justify-content-between align-items-center"
              >
                <span class="" v-if="release.type == 'credit'">
                  <v-icon class="text-success" name="cash-up" />
                  Adicionou <b> {{ release.value | currency }}</b> em créditos
                  para
                  <v-link
                    @click="openVibbranteNewTab(release.vibbrante_slug)"
                    >{{ release.vibbrante_name }}</v-link
                  >
                </span>
                <span class="" v-if="release.type == 'pending'">
                  <v-icon class="text-warning" name="cash-up" />
                  Solicitou <b> {{ release.value | currency }}</b> em créditos
                  para
                  <v-link
                    @click="openVibbranteNewTab(release.vibbrante_slug)"
                    >{{ release.vibbrante_name }}</v-link
                  >. Aguardando liberação.
                </span>
                <span class="" v-if="release.type == 'debit'">
                  <v-icon class="text-danger" name="cash-down" />
                  Aprovou pagamento de
                  <b> {{ release.value | currency }}</b> para
                  <v-link
                    @click="openVibbranteNewTab(release.vibbrante_slug)"
                    >{{ release.vibbrante_name }}</v-link
                  >
                </span>
                <small>{{ release.date | moment('DD/MM/YYYY') }}</small>
              </v-item>
              <!--v-item tag="li" class="d-flex justify-content-between align-items-center">
                <span class=""><v-icon class="text-danger" name="cash-down"/> Reembolsou <b>R$4.000</b>
                </span>
                <small>23/08/2018</small>
              </v-item-->
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- MODALS -->
    <v-modals
      name="user"
      :show="user_modal_show"
      :data="{ user: selected_vibbrante }"
      @onHide="user_modal_show = false"
    />
    <v-modals
      name="wallet-add-credit"
      :show="add_credit_modal_show"
      :data="{ actives_contracts: ableContracts }"
      @onHide="add_credit_modal_show = false"
      @refreshWallet="refreshWallet"
    />
  </v-page>
</template>

<script>
import clientApi from '@/api/client';

export default {
  props: {
    profile: String,
  },
  data() {
    return {
      pago: false,
      user_modal_show: false,
      add_credit_modal_show: false,
      extract_data: [],
      balances_data: [],
      selected_vibbrante: {},
      ableContracts: [],
      selected_month: this.$moment().format(),
    };
  },
  created() {
    this.fetchData();
  },
  watch: {
    selected_month(newValue) {
      this.reloadExtract(newValue);
    },
  },
  methods: {
    reloadExtract(month) {
      this.selected_month = month;
      console.log(this.selected_month);
      clientApi
        .clientExtract(this.$moment(this.selected_month).format('YYYY-MM-01'))
        .then(response => {
          if (response.status === 200) {
            this.extract_data = response.data;
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
    refreshWallet() {
      this.fetchData();
    },
    pagoAteAqui(n) {
      this.pago = n;
    },
    buyHours() {
      this.add_credit_modal_show = true;
    },
    openVibbranteNewTab(slug) {
      const routeData = this.$router.resolve({
        // name: "client-search-vibbrante",
        path: '/client/search/vibbrante/' + slug,
      });
      window.open(routeData.href, '_blank');
    },
    fetchData() {
      clientApi
        .loadAbleToCreditContracts()
        .then(response => {
          if (response.status === 200) {
            this.ableContracts = response.data;
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });

      clientApi
        .clientExtract(this.$moment(this.selected_month).format('YYYY-MM-01'))
        .then(response => {
          if (response.status === 200) {
            this.extract_data = response.data;
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });

      clientApi
        .clientBalances()
        .then(response => {
          if (response.status === 200) {
            this.balances_data = response.data;
            this.$store.dispatch('loadClientBalance', response.data);
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
  },
  computed: {
    activesContracts() {
      return this.$store.getters.client_actives_contracts;
    },
  },
};
</script>

<style lang="scss">
.wallet {
  .statement {
    .card-title {
      & > h5 {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .form-group {
          margin: 0;
        }
      }
    }
  }
  .cash-col {
    display: flex;
    flex-direction: column;
    align-items: center;

    h4 {
      font-weight: 300;
      font-size: 1.4em;
      color: gray(600);
      margin: 0;
      .icon {
        font-size: 0.7em;
        color: gray(400);
      }
      b {
        font-size: 1.6em;
        font-weight: 300;
        color: gray(900);
      }
    }
    h5 {
      font-size: 1.1em;
      margin: 0;
      color: gray(500);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/pages/client/wallet.vue